import React, { useEffect, useState } from "react";
import axios from "axios";
import { Trash2, Plus } from "lucide-react";
import { CATEGORIES } from "../../data/catalog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// -------------------------------------------------------------
// Sub-categories
// -------------------------------------------------------------
function SubCategoriesTab() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ parentCategory: "silver", slug: "", label: "" });
  const [error, setError] = useState("");

  const load = () => {
    setLoading(true);
    axios
      .get(`${API}/admin/subcategories`)
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    const slug = form.slug.trim().toLowerCase().replace(/\s+/g, "-");
    if (!slug || !form.label.trim()) {
      setError("Slug and label are required.");
      return;
    }
    try {
      await axios.post(`${API}/admin/subcategories`, { ...form, slug });
      setForm({ ...form, slug: "", label: "" });
      load();
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.detail) ||
          "Failed to add"
      );
    }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this sub-category? Existing designs inside it will keep their category label.")) return;
    try {
      await axios.delete(`${API}/admin/subcategories/${id}`);
      load();
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const status = err?.response?.status;
      alert(
        `Could not delete this sub-category.\n${detail || err.message || ""}${
          status ? ` (HTTP ${status})` : ""
        }`
      );
    }
  };

  return (
    <div>
      <h1 className="admin-h1">Sub-categories</h1>
      <p className="admin-sub">
        Add new sub-categories under any existing top-level category (Gold, Silver, etc.).
      </p>

      <div className="admin-card">
        <h3>Add a sub-category</h3>
        <form onSubmit={submit} className="admin-form">
          <div className="admin-row three">
            <label>
              <span>Under</span>
              <select
                value={form.parentCategory}
                onChange={(e) => setForm({ ...form, parentCategory: e.target.value })}
              >
                {CATEGORIES.map((c) => (
                  <option key={c.slug} value={c.slug}>
                    {c.label}
                  </option>
                ))}
              </select>
            </label>
            <label>
              <span>Slug (URL)</span>
              <input
                type="text"
                value={form.slug}
                onChange={(e) => setForm({ ...form, slug: e.target.value })}
                placeholder="anklets"
              />
            </label>
            <label>
              <span>Label</span>
              <input
                type="text"
                value={form.label}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
                placeholder="Silver Anklets"
              />
            </label>
          </div>
          {error && <div className="admin-error">{error}</div>}
          <button type="submit" className="btn btn-primary">
            <Plus size={16} /> Add Sub-category
          </button>
        </form>
      </div>

      <div className="admin-card">
        <h3>
          Custom sub-categories <span className="admin-count">({items.length})</span>
        </h3>
        {loading ? (
          <p className="admin-muted">Loading…</p>
        ) : items.length === 0 ? (
          <p className="admin-muted">You haven&apos;t added any yet.</p>
        ) : (
          <div className="admin-list">
            {items.map((s) => (
              <div className="admin-list-item" key={s.id}>
                <div className="admin-list-body">
                  <strong>{s.label}</strong>
                  <span>Under {s.parentCategory} · slug: {s.slug}</span>
                </div>
                <button type="button" className="admin-del" onClick={() => del(s.id)}>
                  <Trash2 size={14} />
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default SubCategoriesTab;
